import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { Skeleton } from 'primereact/skeleton';
import UpdateButton from '../../../Componentes/UpdateButton';
import DeleteButton from '../../../Componentes/DeleteButton';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import InputCEP from '../../../Componentes/InputTextCEP';

export default function FormLocaisInstalacaoCliente(props) {
    const {Conexao } = props;
    const [edicao, setEdicao]  = useState(false);
    const [cadastro, setCadastro]  = useState(false);
    const [locaisInstalacao, setLocaisInstalacao] = useState([]);
    const [localInstalacao, setLocalInstalacao] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({});

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (props.locaisInstalacao) {
            setLocaisInstalacao(props.locaisInstalacao);
            setLoading(false);
        }
    }, [props.locaisInstalacao]);

    useEffect(() => {
        if(!edicao){
            setLocalInstalacao({})
        }
    }, [edicao]);

     useEffect(() => {
        if(!cadastro){
            setLocalInstalacao({})
        }
    }, [cadastro]);

    useEffect(() => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            descricao: { value: null, matchMode: FilterMatchMode.CONTAINS },
            logradouro: { value: null, matchMode: FilterMatchMode.CONTAINS },
            numero: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: null, matchMode: FilterMatchMode.CONTAINS },
            estado: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
    }, []);

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            descricao: { value: null, matchMode: FilterMatchMode.CONTAINS },
            logradouro: { value: null, matchMode: FilterMatchMode.CONTAINS },
            numero: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: null, matchMode: FilterMatchMode.CONTAINS },
            estado: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
        setFilters((prevFilters) => ({
            ...prevFilters,
            global: { value, matchMode: FilterMatchMode.CONTAINS }
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalInstalacao(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const insertCliente = () =>{
        Conexao.post('locaisInstalacaoClienteController/insertLocalCliente', {
            ...localInstalacao
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setLocalInstalacao((prevLocal)=>[{
                    ...localInstalacao, 
                    idlocal : response.data.payload.idlocal
                }])

                props.setLocaisInstalacao((prevLocais) => [
                    ...prevLocais.filter(local => local.idlocal !== localInstalacao.idlocal), 
                    {...localInstalacao, edicao : false}
                ]);
                setEdicao(false)
                setCadastro(false)

                props.showMessageToast('success', 'Registro inserido com sucesso!')
            }else{
                props.showMessageToast('warn', 'Não foi possível inserir!')
            }
        }).catch(error=>{
            props.showMessageToast('warn', 'Não foi possível inserir! Erro ao conectar o serviço remoto!')
        })
    }

    const updateLocalClientes = () =>{
        console.log(localInstalacao)
        
        Conexao.post('locaisInstalacaoClienteController/updateLocalClientes', {
            ...localInstalacao
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){

                props.setLocaisInstalacao((prevLocais) => [
                    ...prevLocais.filter(local => local.idlocal !== localInstalacao.idlocal), 
                    {...localInstalacao, edicao : false}
                ]);

                setEdicao(false)
                setCadastro(false)

                props.showMessageToast('success', 'Registro alterado com sucesso!')

            }else{

                props.showMessageToast('warn', 'Não foi possível alterar!')

            }
        }).catch(error=>{

            props.showMessageToast('warn', 'Não foi possível alterar! Erro ao conectar o serviço remoto!')

        })
    }

    const deleteLocalClientes = (idcliente, idlocal) =>{
        console.log(localInstalacao)
        
        Conexao.post('locaisInstalacaoClienteController/deleteLocalClientes', {
            idcliente : idcliente, 
            idlocal : idlocal 
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){              
                props.setLocaisInstalacao((prevLocais) => [
                    ...prevLocais.filter(local => local.idlocal !== idlocal), 
                ]);
                props.showMessageToast('success', 'Registro excluido com sucesso!')

            }else{

                props.showMessageToast('warn', 'Não foi possível excluir!')

            }
        }).catch(error=>{

            props.showMessageToast('warn', 'Não foi possível excluir! Erro ao conectar o serviço remoto!')

        })
    }



    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-plus" 
                        disabled ={props.fixarCliente}
                        className= "p-button-primary p-button-sm" 
                        onClick={()=>{
                            
                            
                            setLocalInstalacao({
                                idempresa : props.idempresa, 
                                idcliente : props.idcliente, 
                                bairro: null,
                                cep: null,                              
                                cidade: null,                            
                                complemento: null,                                 
                                descricao: null,                             
                                email:null,  
                                estado: null, 
                                idregiao: null,
                                latitude: null,
                                logradouro: null,
                                longitude: null,
                                numero: null,
                                telefonecelular: null,
                                telefonecomercial: null,
                            })
                            setCadastro(true)
                        }}
                        tooltip="Novo local de instalação" tooltipOptions={{ position: 'bottom' }}
                    />            
                </div>
                
            </div>
        );
    };

    return (
        <div style={{paddingLeft : '0px'}}>
            {
                (edicao || cadastro) ? <React.Fragment>
                    <div className="flex flex-wrap gap-0 "  >
                        {/* Exibindo informações da cliente */}
                        <div className="col-12 md:col-4">
                            <span className="font-medium text-sm">None do Local</span>
                            <InputText           
                                value = {localInstalacao.descricao}                                
                                name="descricao"
                                onChange={handleChange}
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">CEP</span>
                            <InputCEP           
                                value = {localInstalacao.cep} 
                                onChange={handleChange}  
                                setDataCep = {(data)=>{
                                    setLocalInstalacao((prevLocal)=>({
                                        ...prevLocal, 
                                        logradouro : data.logradouro, 
                                        complemento : data.complemento, 
                                        bairro : data.bairro, 
                                        cidade : data.localidade,
                                        estado : data.uf
                                    }))
                                }}                             
                                name="cep"
                                className="w-full mt-2"
                            />
                        </div>

                        <div className="col-12 md:col-6">
                            <span className="font-medium text-sm">Logradouro</span>
                            <InputText           
                                value = {localInstalacao.logradouro} 
                                onChange={handleChange}                               
                                name="logradouro"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-1">
                            <span className="font-medium text-sm">Nº</span>
                            <InputText           
                                value = {localInstalacao.numero}  
                                onChange={handleChange}                              
                                name="numero"
                                className="w-full mt-2"
                            />
                        </div>

                        

                        <div className="col-12 md:col-4">
                            <span className="font-medium text-sm">Complemento</span>
                            <InputText           
                                value = {localInstalacao.complemento}  
                                onChange={handleChange}                              
                                name="complemento"
                                className="w-full mt-2"
                            />
                        </div>

                        <div className="col-12 md:col-7">
                            <span className="font-medium text-sm">Bairro</span>
                            <InputText           
                                value = {localInstalacao.bairro}   
                                onChange={handleChange}                             
                                name="bairro"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-10">
                            <span className="font-medium text-sm">Cidade</span>
                            <InputText           
                                value = {localInstalacao.cidade}   
                                onChange={handleChange}                             
                                name="cidade"
                                className="w-full mt-2"
                            />
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Estado</span>
                            <InputText           
                                value = {localInstalacao.estado}   
                                onChange={handleChange}                             
                                name="estado"
                                className="w-full mt-2"
                            />
                        </div>

                    </div>
                    <div className="mt-4 flex justify-content-end mt-2">
                        <Button disabled={props.fixarCliente} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                confirmDialog({
                                message: 'Deseja cancelar?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    setLocalInstalacao([])
                                    setEdicao(false)
                                    setCadastro(false)
                                }
                            });
                        }} />
                        <Button disabled={props.fixarCliente} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                               
                                confirmDialog({
                                message: 'Confirma a inclusão desse novo Cliente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    if(cadastro){
                                        insertCliente();
                                    }else if(edicao){
                                        updateLocalClientes();
                                    }
                                    

                                }
                            });
                        }} />
                    </div>

                </React.Fragment> : 
            
            <DataTable
                value={locaisInstalacao}
                header={renderHeader()}
                paginator
                rows={10}
                responsiveLayout="scroll"
                filters={filters}
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                tableStyle={{ minWidth: '35rem', fontSize : '10px' }}
                globalFilterFields={['descricao', 'logradouro', 'numero', 'cidade', 'estado']}
            >
                <Column field="descricao" header="Nome Local" sortable />
                <Column field="logradouro" header="Logradouro" sortable />
                <Column field="numero" header="Nº" sortable />
                <Column field="cidade" header="Cidade" sortable />
                <Column field="estado" header="Estado" sortable />
                <Column header="Editar" body={(row) => <UpdateButton disabled={row.descricao?.trim() ==='LOCAL PADRAO'} onClick = {()=>{
                    setEdicao(true)
                    setLocalInstalacao((prevLocal) => ({
                        ...prevLocal,  // Mantém os dados anteriores
                        ...row,  
                              // Substitui os valores por `row`                       
                    }));
                    
                }                
                }/>} />
                <Column header="Excluir" body={(row) => <DeleteButton severity='danger' disabled={row.descricao?.trim() ==='LOCAL PADRAO'} onClick ={()=>{
                    confirmDialog({
                                message: 'Confirma a exclusão desse Local?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    deleteLocalClientes(row.idcliente, row.idlocal);
                                }
                            });
                }}/>} />
            </DataTable> }
        </div>
    );
}
